
export default function AmbientBg({
    colorClass,
    positionClass
}) {
  return (
    <div className={`w-[200px] sm:w-[500px] h-[200px] sm:h-[500px] rotate-45 sm:blur-[300px] blur-[150px] rounded-full absolute ${colorClass} ${positionClass}`} />
  )
}
